module.exports = __webpack_public_path__ + "static/media/posto-bomba.a550ebd0.svg";